import { Routes } from '@angular/router';
import { TimeTrackerPageComponent } from './pages/time-tracker-page/time-tracker-page.component';

export const timeTrackerRoutes: Routes = [
  {
    path: 'tracker',
    loadComponent: () =>
      import('./pages/time-tracker-page/time-tracker-page.component').then(
        () => TimeTrackerPageComponent,
      ),
  },
];
